module.exports = __webpack_public_path__ + "img/transfer_from_warehouse.94dc39c1.svg";